module.exports = __webpack_public_path__ + "static/media/instagram-logo-svgrepo-com.f30c7918.svg";